import {
  REQUEST_BIRTHDAYS,
  REQUEST_BIRTHDAYS_SUCCESS,
  REQUEST_BIRTHDAYS_FAILURE,
} from 'constants/ActionTypes';

import { custom } from 'utils/Api';

export const requestBirthdays = () => ({
  type: REQUEST_BIRTHDAYS,
});

export const requestBirthdaysSuccess = birthdays => ({
  type: REQUEST_BIRTHDAYS_SUCCESS,
  birthdays,
});

export const requestBirthdaysFailure = error => ({
  type: REQUEST_BIRTHDAYS_FAILURE,
  error,
});

export const fetchBirthdays = () =>
  (dispatch, getState) => {
    dispatch(requestBirthdays());
    const {
      loginReducer: { token },
    } = getState();

    const config = {
      url: 'api/HrData/EmployeeBirthday',
      headers: { Authorization: `Bearer ${token}` },
      method: 'GET',
    };

    custom(config)
      .then(res => dispatch(requestBirthdaysSuccess(res.data)))
      .catch(err => dispatch(requestBirthdaysSuccess(err)));
  };



// WEBPACK FOOTER //
// ./src/actions/Birthdays.js